import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  return {
    summaryRoot: {
      "&.Mui-expanded": {
        minHeight: 30
      },
      minHeight: 30,
      height: 30,
      paddingLeft: 8,
      [theme.breakpoints.up("sm")]: {
        height: 40
      }
    },
    expanded: {
      [theme.breakpoints.up("sm")]: {
        height: 40
      }
    },
    header: {
      position: "relative"
    },
    summaryContent: {
      alignItems: "center",
      fontWeight: "bold",
      paddingLeft: 10
    },
    details: {
      display: "flex",
      flexDirection: "column",
      padding: 0
    },
    expandIconTrainer: {
      order: -1,
      color: "black",
      padding: 0
    },
    rowMenu: {
      position: "absolute",
      top: 0,
      right: 23,
      bottom: 0,
      padding: "0 4px",
      overflow: "hidden",
      zIndex: 1
    },
    headerFiller: {
      display: "flex",
      alignItems: "center",
      height: "100%",
      width: 60,
      backgroundColor: "#fff",
      boxShadow: "0 0 4px 0 #ccc"
    },
    expandIcon: {
      fontSize: 32
    }
  };
});
